var CBean = {};

CBean.Log = {           // dSort 01
    // dId
    dId: '',
    // dDate
    dData: '',
    // 最终交易时间
    reviseTime: '',
    // 修正状态 // 0未修正；1修正
    reviseFlag: '',
    //未知支付标识
    unknowPay: '',
    // 交易时间
    date: '',
    // SID
    sid: '',
    // 实际交易额
    money: '',
    // 日志类型(增加)
    // 0:销售: '',1:退货: '',2:未确认: '',
    //3:清除: '',4:挂单: '',5:自动模式: '',
    //6~9:预留: '',10:入库: '',11:出库: '',
    //12:盘库: '',13:订单: '',14:损耗
    //255:错误日志
    logType: '',
    // 累计数
    number: '',
    // 现金
    cash: '',
    // 营业员编号
    shopManId: '',
    // 折舍金额
    amountOfDiscount: '',
    // 税额
    cesse: '',
    // 成本
    cost: '',
    // 卡付
    cardPayment: '',
    // 其他支付1
    otherPay1: '',
    // 其他支付2
    otherPay2: '',
    // 其他支付3
    otherPay3: '',
    // 服务费
    serviceCharge: '',
    // CoFID
    coFid: '',
    // 支付宝
    aliPay: '',
    // 微信支付
    weixinPay: '',
    // 特殊支付2(预留) 吉卡云消费
    specialPay2: '',
    // 特殊支付3(预留) 吉卡云赠送金额消费
    specialPay3: '',
    // 特殊支付4(预留)
    specialPay4: '',
    // 特殊支付5(预留)
    specialPay5: '',
    // 特殊支付6(预留)
    specialPay6: '',
    // 特殊支付7(预留)
    specialPay7: '',
    // 错误代码
    errCode: '',
    // 错误文本1
    errMsg1: '',
    // 错误文本2
    errMsg2: '',
    // 错误文本3
    errMsg3: '',
    // 错误文本4
    errMsg4: '',
    // 吉卡云消费金额
    jkyPay: '',
    // 吉卡云赠送支付
    jkyGivePay: '',
    // 充值金额
    recharge: '',
    // 充值赠送
    giveRecharge: '',
    // 商品详情
    goods: [{
        // 单位
        unit: '',
        // PLU编号
        pluNo: '',
        // 数重量
        weigth: '',
        // 单价
        univalent: '',
        // 单计
        singleMeter: '',
        // 商品名
        tradeName: '',
        // 组编号
        groupNo: '',
        // 部门编号
        deptNo: '',
        // 成本
        costTrade: '',
        // 税额
        amount: '',
        // 文本1
        text1: '',
        // 文本2
        text2: '',
        // 文本3
        text3: '',
        // 文本4
        text4: '',
        // 日志类型
        logTypeTrade: ''
    }]
};

CBean.Department = {        // dSort 02
    // 部门编号（数据ID）
    dId: '',
    // 部门名
    name: ''
};

CBean.Group = {             // dSort 03
    // 组别编号（数据ID）
    dId: '',
    // 组别名
    name: '',
    // 所属部门
    department: '',
    // 单据1：打印格式
    putType1: '',
    // 单据1：条码格式
    barType1: '',
    // 单据1：条码标志
    barSgin1: '',
    // 单据2：打印格式
    putType2: '',
    // 单据2：条码格式
    barType2: '',
    // 单据2：条码标志
    barSgin2: '',

    gtArr: function () {
        var arr = [];
        arr.push(this.putType1 ? this.putType1 : '');
        arr.push(this.barType1 ? this.barType1 : '');
        arr.push(this.barSgin1 ? this.barSgin1 : '');
        arr.push(this.putType2 ? this.putType2 : '');
        arr.push(this.barType2 ? this.barType2 : '');
        arr.push(this.barSgin2 ? this.barSgin2 : '');
        return arr;
    }
};

CBean.PLU = {           // dSort 04
    // PLU编号（数据ID）
    dId: '',
    // 商品名
    name: '',
    // 单位
    weigth: '',
    // 单价
    price: '',
    // 货号
    number: '',
    // 索引条码
    indexBar: '',
    // 使用日期打印
    useDatePut: '',
    // 使用日期数据
    useDateData: '',
    // 成本
    costTrade: '',
    // 皮重
    trae: '',
    // 所属组别
    group: '',
    // 打印格式1编号
    putType1: '',
    // 条码1编号
    barNo1: '',
    // 条码1标志
    barType1: '',
    // 打印格式2编号
    putType2: '',
    // 条码2编号
    barNo2: '',
    // 条码2标志
    barType2: '',
    // 商品文本1
    text1: '',
    // 商品文本2
    text2: '',
    // 商品文本3
    text3: '',
    // 商品文本4
    text4: '',
    // 商品文本5
    text5: '',
    // 商品文本6
    text6: '',
    // 商品文本7
    text7: '',
    // 税率种类
    taxType: '',
    // 税率万分比（‱）
    taxExtreme: '',
    // 位图编号
    picNo: '',
    // 销售日期打印
    saleDatePut: '',
    // 销售日期数据
    saleDateData: '',
    // 销售时间打印
    saleTimePut: '',
    // 销售时间数据
    saleTimeData: '',
    // 包装日期打印
    packDatePut: '',
    // 包装日期数据
    packDateData: '',
    // 包装时间打印
    packTimePut: '',
    // 包装时间数据
    packTimeData: '',
    // 手动折扣下限
    manualDiscountLower: '',
    // 手动折扣下限值
    manualDiscountLowerValue: '',
    // 手动折扣上限
    manualDiscountUpper: '',
    // 手动折扣上限值
    manualDiscountUpperValue: '',
    // 订制折扣0种类
    customDiscount0Type: '',
    // 本订制激活日
    customDiscount0UseDate: '',
    // 本订制激活段下限
    customDiscount0Lower: '',
    // 本订制激活段上限
    customDiscount0Upper: '',
    // 本订制打折数
    customDiscount0Value: '',
    // 订制折扣1种类
    customDiscount1Type: '',
    // 本订制激活日
    customDiscount1UseDate: '',
    // 本订制激活段下限
    customDiscount1Lower: '',
    // 本订制激活段上限
    customDiscount1Upper: '',
    // 本订制打折数
    customDiscount1Value: '',
    // 订制折扣2种类
    customDiscount2Type: '',
    // 本订制激活日
    customDiscount2UseDate: '',
    // 本订制激活段下限
    customDiscount2Lower: '',
    // 本订制激活段上限
    customDiscount2Upper: '',
    // 本订制打折数
    customDiscount2Value: '',
    // 订制折扣3种类
    customDiscount3Type: '',
    // 本订制激活日
    customDiscount3UseDate: '',
    // 本订制激活段下限
    customDiscount3Lower: '',
    // 本订制激活段上限
    customDiscount3Upper: '',
    // 本订制打折数
    customDiscount3Value: '',
    // SspValue 1
    sspValue1: '',
    // SspValue 2
    sspValue2: '',
    // SspValue 3
    sspValue3: '',
    // SspValue 4
    sspValue4: '',
    // PLU类型
    pluType: '',
    // PLU标志
    pluSgin: '',
    // PLU标志值
    pluSginValue: '',
    // 拼音检索
    pingyinSearch: '',

    gtArr: function () {
        var arr = [];
        arr.push(this.number ? this.number : '');
        arr.push(this.indexBar ? this.indexBar : '');
        arr.push(this.useDatePut ? this.useDatePut : '' + this.useDateData ? this.useDateData : '');
        arr.push(this.costTrade ? this.costTrade : '');
        arr.push(this.trae ? this.trae : '');
        arr.push(this.group ? this.group : '');
        arr.push(this.putType1 ? this.putType1 : '');
        arr.push(this.barNo1 ? this.barNo1 : '');
        arr.push(this.barType1 ? this.barType1 : '');
        arr.push(this.putType2 ? this.putType2 : '');
        arr.push(this.barNo2 ? this.barNo2 : '');
        arr.push(this.barType2 ? this.barType2 : '');
        arr.push(this.text1 ? this.text1 : '');
        arr.push(this.text2 ? this.text2 : '');
        arr.push(this.text3 ? this.text3 : '');
        arr.push(this.text4 ? this.text4 : '');
        arr.push(this.text5 ? this.text5 : '');
        arr.push(this.text6 ? this.text6 : '');
        arr.push(this.text7 ? this.text7 : '');
        arr.push(this.taxType ? this.taxType : '' + this.taxExtreme ? this.taxExtreme : '');
        arr.push(this.picNo ? this.picNo : '');
        arr.push(this.saleDatePut ? this.saleDatePut : '' + this.saleDateData ? this.saleDateData : '');
        arr.push(this.saleTimePut ? this.saleTimePut : '' + this.saleTimeData ? this.saleTimeData : '');
        arr.push(this.packDatePut ? this.packDatePut : '' + this.packDateData ? this.packDateData : '');
        arr.push(this.packTimePut ? this.packTimePut : '' + this.packTimeData ? this.packTimeData : '');
        arr.push(this.manualDiscountLower ? this.manualDiscountLower : '' + this.manualDiscountLowerValue ? this.manualDiscountLowerValue : '');
        arr.push(this.manualDiscountUpper ? this.manualDiscountUpper : '' + this.manualDiscountUpperValue ? this.manualDiscountUpperValue : '');
        // console.log(this.manualDiscountUpper + this.manualDiscountUpperValue)
        arr.push(this.customDiscount0Type ? this.customDiscount0Type : '' + this.customDiscount0UseDate ? this.customDiscount0UseDate : '' + this.customDiscount0Lower ? this.customDiscount0Lower : '' + this.customDiscount0Upper ? this.customDiscount0Upper : '' + this.customDiscount0Value ? this.customDiscount0Value : '');
        arr.push(this.customDiscount1Type ? this.customDiscount1Type : '' + this.customDiscount1UseDate ? this.customDiscount1UseDate : '' + this.customDiscount1Lower ? this.customDiscount1Lower : '' + this.customDiscount1Upper ? this.customDiscount1Upper : '' + this.customDiscount1Value ? this.customDiscount1Value : '');
        arr.push(this.customDiscount2Type ? this.customDiscount2Type : '' + this.customDiscount2UseDate ? this.customDiscount2UseDate : '' + this.customDiscount2Lower ? this.customDiscount2Lower : '' + this.customDiscount2Upper ? this.customDiscount2Upper : '' + this.customDiscount2Value ? this.customDiscount2Value : '');
        arr.push(this.customDiscount3Type ? this.customDiscount3Type : '' + this.customDiscount3UseDate ? this.customDiscount3UseDate : '' + this.customDiscount3Lower ? this.customDiscount3Lower : '' + this.customDiscount3Upper ? this.customDiscount3Upper : '' + this.customDiscount3Value ? this.customDiscount3Value : '');
        arr.push(this.sspValue1 ? this.sspValue1 : '');
        arr.push(this.sspValue2 ? this.sspValue2 : '');
        arr.push(this.sspValue3 ? this.sspValue3 : '');
        arr.push(this.sspValue4 ? this.sspValue4 : '');
        arr.push(this.pluType ? this.pluType : '');
        arr.push(this.pluSgin ? this.pluSgin : '');
        arr.push(this.pluSginValue ? this.pluSginValue : '');
        arr.push(this.pingyinSearch ? this.pingyinSearch : '');
        return arr;
    }
};

CBean.BarCode = {       // dSort 05
    // 条码格式编号（数据ID）
    dId: '',
    // 条码格式名
    name: '',
    // 条码格式种类
    type: '',
    // 条码描述符
    description: '',
    // 校验方式
    checkType: '',
    // 常数1
    constant1: '',
    // 常数2
    constant2: '',
    gtArr: function () {
        var arr = [];
        arr.push(this.checkType ? this.checkType : '');
        arr.push(this.constant1 ? this.constant1 : '');
        arr.push(this.constant2 ? this.constant2 : '');
        return arr;
    }
};

CBean.Put = {           // dSort 06
    // 打印格式编号（数据ID）
    dId: '',
    // 打印格式名
    name: '',
    // 打印格式种类
    type: '',
    // 字体模式
    fontMode: '',
    // 高度
    high: '',
    // 宽度
    width: '',
    // 子项数量
    sonCount: '',
    // 文本0
    text0: '',
    // 文本1
    text1: '',
    // 文本2
    text2: '',
    // 文本3
    text3: '',
    // 文本4
    text4: '',
    // 文本5
    text5: '',
    // 文本6
    text6: '',
    // 文本7
    text7: '',
    // 文本8
    text8: '',
    // 文本9
    text9: '',
    // 文本10
    text10: '',
    // 文本11
    text11: '',
    // 文本12
    text12: '',
    // 文本13
    text13: '',
    // 文本14
    text14: '',
    // 文本15
    text15: '',
    // 文本16
    text16: '',
    // 文本17
    text17: '',
    // 文本18
    text18: '',
    // 文本19
    text19: '',
    // 文本20
    text20: '',
    // 文本21
    text21: '',
    // 文本22
    text22: '',
    // 文本23
    text23: '',
    // 文本24
    text24: '',
    // 文本25
    text25: '',
    // 文本26
    text26: '',
    // 文本27
    text27: '',
    // 文本28
    text28: '',
    // 文本29
    text29: '',
    // 文本30
    text30: '',
    // 文本31
    text31: '',

    gtArr: function () {
        var arr = [];
        arr.push(this.text1 ? this.text1 : '');
        arr.push(this.text2 ? this.text2 : '');
        arr.push(this.text3 ? this.text3 : '');
        arr.push(this.text4 ? this.text4 : '');
        arr.push(this.text5 ? this.text5 : '');
        arr.push(this.text6 ? this.text6 : '');
        arr.push(this.text7 ? this.text7 : '');
        arr.push(this.text8 ? this.text8 : '');
        arr.push(this.text9 ? this.text9 : '');
        arr.push(this.text10 ? this.text10 : '');
        arr.push(this.text11 ? this.text11 : '');
        arr.push(this.text12 ? this.text12 : '');
        arr.push(this.text13 ? this.text13 : '');
        arr.push(this.text14 ? this.text14 : '');
        arr.push(this.text15 ? this.text15 : '');
        arr.push(this.text16 ? this.text16 : '');
        arr.push(this.text17 ? this.text17 : '');
        arr.push(this.text18 ? this.text18 : '');
        arr.push(this.text19 ? this.text19 : '');
        arr.push(this.text20 ? this.text20 : '');
        arr.push(this.text21 ? this.text21 : '');
        arr.push(this.text22 ? this.text22 : '');
        arr.push(this.text23 ? this.text23 : '');
        arr.push(this.text24 ? this.text24 : '');
        arr.push(this.text25 ? this.text25 : '');
        arr.push(this.text26 ? this.text26 : '');
        arr.push(this.text27 ? this.text27 : '');
        arr.push(this.text28 ? this.text28 : '');
        arr.push(this.text29 ? this.text29 : '');
        arr.push(this.text30 ? this.text30 : '');
        arr.push(this.text31 ? this.text31 : '');
    },

    putSons: [{
        // 子项编号
        number: '',
        // 子项标志0
        sgin0: '',
        // 子项标志1
        sgin1: '',
        // 子项标志2
        sgin2: '',
        // 打印条件
        term: '',
        // 打印角度
        angle: '',
        // 对齐模式
        align: '',
        // 字体编号
        fontNum: '',
        // 起点坐标-横向
        horizontal: '',
        // 起点坐标-纵向
        vertical: '',
        // 文本框-宽度
        width: '',
        //文本框-高度
        high: ''
    }]
};

CBean.Assistant = {         // dSort 07
    // 营业员编号（数据ID）
    dId: '',
    // 营业员名
    name: '',
    // 营业员密码
    pwd: '',
    // 折扣下限
    discountLower: '',
    // 折扣上限
    discountUpper: '',
    // 权限控制
    security: '',
    // 营业员编码
    number: '',

    gtArr: function () {
        var arr = [];
        arr.push(this.pwd ? this.pwd : '');
        arr.push(this.discountLower ? this.discountLower : '');
        arr.push(this.discountUpper ? this.discountUpper : '');
        arr.push(this.security ? this.security : '');
        arr.push(this.number ? this.number : '');
    }
};

CBean.Data = {              // dSort 08
    // 数据参数编号（数据ID）
    dId: '',
    // 数据参数内容
    value: ''
};

CBean.Text = {              // dSort 09
    // 文本参数编号（数据ID）
    dId: '',
    // 文本参数内容
    value: ''
};

CBean.Keyboard = {          // dSort 10
    // 快捷键编号（数据ID）
    dId: '',
    // 快捷键对应PLU编号或功能键编号
    value: ''
};

CBean.Character_bank = {    // dSort 11
    // 字库编号（数据ID）
    dId: '',
    // 字库文件
    dData: ''
};

CBean.Bitmaps = {           // dSort 12
    // 位图编号（数据ID）
    dId: '',
    // 位图文件
    dData: ''
};

CBean.Update_file = {       // dSort 13
    // 更新编号（数据ID）
    dId: '',
    // 更新文件
    dData: ''
};

CBean.Remote_print = {      // dSort 14
    // 远程打印编号（数据ID）
    // 0：参数数据，目前无用
    // 1：终结数据
    // 2：起始数据
    // 3：中间数据
    // 服务器发送时，始终发送"1"即可
    dId: '',
    // 远程打印数据
    dData: ''
};

CBean.Communication_hardware = {    // dSort 255
    // 秤的硬件信息
    dId: '01',
    // MAC
    mac: '',
    // 时区状态（未绑定状态下=0）
    utc4: '',
    // 当前连接使用的网络    'C'=有线网连接   'W'=无线网连接
    line: '',
    // 有线网IP 如果没有连接则=0
    wire_ip: '',
    // 无线网IP 如果没有连接则=0
    wireless_ip: '',
    // 数据存储容量
    data_storage: '',
    // 字库存储容量
    font_storage: '',
    // 编码格式 'C'=GB2312/GBK编码 'U'=UTF-8编码
    charset: '',
    encoding: '',
    // 默认字库编号
    default_font_number: '',
    // 固件版本信息
    version: ''
};

CBean.Communication_discern = {    // dSort 255
    // 秤的识别信息
    dId: '02',
    // 商店名  对应文本参数0
    store_name: '',
    // 机器名  对应文本参数1
    device_name: '',
    // 机器号 对应数据参数40
    device_num: ''
};

CBean.Communication_date = {    // dSort 255
    // 秤的时间信息
    dId: '03',
    // 当前时间 基于2000.01.01 00:00:00的秒数
    time: ''
};

/**
 * 汽车衡数据参数
 * @type {{dId: string, dData: string}}
 */
CBean.Truck_Data = {       // dSort 0201
    // 更新编号（数据ID）
    dId: '',
    // 更新文件
    dData: ''
};

// 发送单转换对象
CBean.send = {
    dCmd: '11',
    dataParts: [{
        dSort: '',
        dId: '',
        dData: ''
    }]
};

// 删除请求
CBean.delete = {
    dCmd: '10',
    dataParts: [{
        dSort: '',
        dId: '',
        dData: ''
    }]
};

// 发送单转换对象
CBean.request = {
    dCmd: '01',
    dataParts: [{
        dSort: '',
        dId: '',
        dData: ''
    }]
};
export default CBean;


//////////////////
// WEBPACK FOOTER
// ./api/agreement/cr-agreement/bean.js
// module id = bKSE
// module chunks = 28